import moderation from '@/components/services/invoices/item/buttons/moderation'
import { invoiceStatues } from '@/components/services/invoices/utils'

export default function(h) {
  if (this.hasPermission) {
    return h(
      'div',
      {
        class: 'flex grid-gap--8'
      },
      [ invoiceStatues.paid, invoiceStatues.rejected ].map(status => {
        return h(
          moderation,
          {
            props: {
              status,
              value: this.value,
              view: 'form'
            }
          }
        )
      })
    )
  }
}
